function checkWizzyConfigAndUpdate() {
  if (window.wizzyConfig) {
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
    clearInterval(interval);
  }
}

var interval = setInterval(checkWizzyConfigAndUpdate, 10);

// var interval = setInterval(checkWizzyConfigAndUpdate, 10);

window.onWizzyScriptLoaded = function () {
  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-search-results");
  replaceTemplate("wizzy-search-empty-results");
  replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-autocomplete-suggestions");
  replaceTemplate("wizzy-autocomplete-wrapper");
  replaceTemplate("wizzy-search-summary");
  replaceTemplate("wizzy-common-select");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: ".wizzy-search-input",
          type: "text",
        },
      ];
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
        "#main"
      );
      window.wizzyConfig.common.isLazyInit = true;

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
   data?.payload?.categories?.forEach(category => {
  // 1. Clean filters.categories[]
  if (category.filters && Array.isArray(category.filters.categories)) {
    category.filters.categories = category.filters.categories.map(catValue => {
      return (typeof catValue === 'string' && catValue.endsWith('_wzAc'))
        ? catValue.replace(/_wzAc$/, '')
        : catValue;
    });
  }

  category.payload.forEach(item => {
    if (typeof item.value === 'string' && item.value.endsWith('_wzAc')) {
      item.value = item.value.replace(/_wzAc$/, '');
    }

    if (item.key === "relatedCategories" && Array.isArray(item.value)) {
      item.value.forEach(related => {
        if (typeof related.id === 'string' && related.id.endsWith('_wzAc')) {
          related.id = related.id.replace(/_wzAc$/, '');
        }

        if (typeof related.url === 'string' && related.url.includes('_wzAc')) {
          related.url = related.url.replace(/_wzAc$/, '');
        }

        if (Array.isArray(related.pathIds)) {
          related.pathIds = related.pathIds.map(id =>
            typeof id === 'string' && id.endsWith('_wzAc')
              ? id.replace(/_wzAc$/, '')
              : id
          );
        }
      });
    }
  });
});

      console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: "wizzy-search-input",
          type: "text",
        },
      ];
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
        "#main"
      );
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 2e3,
        mobile: 2e3,
      };

      window.wizzyConfig.search.configs.general.minQueryLength = 1;

      // payload.autocomplete.configs.defaultBehaviour.suggestions.enabled = true;

      // wizzyConfig.autocomplete.configs.defaultBehaviour.suggestions.defaultPool = [
      //     {
      //         "value": "Plantes",
      //         "valueHighlighted": "Plantes",
      //         "filters": [],
      //         "payload": [],
      //         "section": "others"
      //     }
      // ]

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")

      payload.forEach((product) => {
        product.showSelectedVarint = "";
        product.subTitleOne = "";
        product.judgeReview = "";
        product.reviewAvailable = false;
        product.prixEnBaisse = false;
        product.lowestVariantSelected = false;
        product.orderable = true;

        // product.petitPrix = false;
        product.labelPlanteBleue = false;
        product.labelADR = false;
        // product.planteSuspendue = false;
        // product.exclusivité = false;
        if (product.attributes) {
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_Title") {
              if (attribute.values[0].value[0]) {
                product.showSelectedVarint = attribute.values[0].value[0];
                // console.log(attribute.values[0].value[0], ' <---- ')
              }
            }
            if (attribute.id === "product_superbullet_global") {
              if (attribute.values[0].value[0]) {
                product.subTitleOne = attribute.values[0].value[0];
              }
            }

            if (attribute.id === "product_badge_judgeme") {
              if (attribute.values[0].value[0]) {
                product.judgeReview = attribute.values[0].value[0];

                const judgeMeReview = document.createElement("div");
                judgeMeReview.innerHTML = product.judgeReview;

                const badgeElement =
                  judgeMeReview.querySelector(".jdgm-prev-badge");
                product.numberOfReviews = null;
                if (badgeElement) {
                  product.numberOfReviews = badgeElement.getAttribute(
                    "data-number-of-reviews"
                  );
                }
                // console.log(product.numberOfReviews);
                if (product.numberOfReviews > 0) {
                  product.reviewAvailable = true;
                }
              }
            }

            if (attribute.id === "product_Spécifications_tags") {
              if (attribute.values?.length > 0 && attribute.values) {
                attribute.values.forEach((item) => {
                  console.log("product_Spécifications_tags", item);
                  if (item.value[0] === "Label Plante Bleue") {
                    product.labelPlanteBleue = true;
                  }
                  if (item.value[0] === "Label ADR") {
                    product.labelADR = true;
                  }
                });
                // if(item === "Petit prix") {
                //   product.petitPrix = true;
                // }
                // if(item === "Plante suspendue") {
                //   product.planteSuspendue = true;
                // }
                // if(item === "Exclusivité") {
                //   product.exclusivité = true;
                // }
              }
            }

            if (attribute.id === "product_tags") {
              if (attribute.values[0].value[0]) {
                if (attribute.values[0].value[0].includes("Prix en baisse")) {
                  product.prixEnBaisse = true;
                  // console.log(product.prixEnBaisse,"product.prixEnBaisse")
                }
              }
            }

            if (attribute.id === "product_variant_prices") {
              if (attribute.values.length > 1) {
                const listVariant = attribute.values;

                const lowestValue = listVariant
                  .filter((variant) => variant.inStock)
                  .reduce((min, variant) => {
                    const currentValue = variant.value[0];
                    return currentValue < min ? currentValue : min;
                  }, Infinity);

                if (lowestValue == product.sellingPrice) {
                  product.lowestVariantSelected = true;
                  // console.log(product.lowestVariantSelected)
                }
              }
            }

            if (attribute.id === "product_Orderable_tags") {
              if (attribute.values[0].value[0]) {
                if (attribute.values[0].value[0] == "No") {
                  product.orderable = false;
                }
              }
            }
          });
        }
      });

      return payload;
    }
  );

  const addSorting = (filter) => {
    let newSort = [];
    newSort.push(
      {
        field: "relevance",
        order: "asc",
      },
      {
        field: "sellingPrice",
        order: "asc",
      }
    ),
      (filter.sort = newSort);
    // console.log("WIZ ADDING NEW SORT", filter.sort);
  };

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      payload.minQueryLength = 1;
      addSorting(payload);
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {

      addSorting(payload);
      var closeIcon = document.getElementById("internal-close-icon");
      if (closeIcon) {
        closeIcon.click();
      }

      if (payload.sort) {
        if (payload.sort.length == 1 && payload.sort[0].field === "relevance") {
          payload.sort.unshift({
            field: "product_Orderable_tags",
            order: "desc",
          });
        }
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");

      if (payload.filters.sort && payload.filters.sort.length === 1) {
        const sortCriteria = payload.filters.sort[0];
        if (sortCriteria.field === "sellingPrice") {
          // console.log("Sorting canceled.");
          payload.filters.showOOSProductsInOrder = "true";
        }
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      // Select all elements containing the review counts
      const reviewBadges = document.querySelectorAll(".jdgm-prev-badge__text");
      reviewBadges.forEach((reviewBadge) => {
        const reviewCount = reviewBadge.textContent.match(/\d+/)[0]; // Extract the number
        reviewBadge.textContent = `${reviewCount} avis`;
      });

      ////////////////////////////////////
      const items = document.querySelectorAll(
        '.wizzy-facet-list-item[data-term="No"], .wizzy-facet-list-item[data-term="Yes"]'
      );
      if (items.length > 0) {
        items.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.textContent = label.textContent === "No" ? "Non" : "Oui";
          }
        });
      }

      ////////////////////////////////////////
      const selectedItems = document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-term="No"], .wizzy-selected-facet-list-item[data-term="Yes"]'
      );
      if (selectedItems.length > 0) {
        selectedItems.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.innerHTML = label.innerHTML
              .replace("No", "Non")
              .replace("Yes", "Oui");
          }
        });
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log(data," <= PRODUCTS_CACHED_RESULTS_RENDERED");

      // Select all elements containing the review counts
      const reviewBadges = document.querySelectorAll(".jdgm-prev-badge__text");
      reviewBadges.forEach((reviewBadge) => {
        const reviewCount = reviewBadge.textContent.match(/\d+/)[0]; // Extract the number
        reviewBadge.textContent = `${reviewCount} avis`;
      });

      ////////////////////////////////////
      const items = document.querySelectorAll(
        '.wizzy-facet-list-item[data-term="No"], .wizzy-facet-list-item[data-term="Yes"]'
      );
      if (items.length > 0) {
        items.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.textContent = label.textContent === "No" ? "Non" : "Oui";
          }
        });
      }

      ////////////////////////////////////////
      const selectedItems = document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-term="No"], .wizzy-selected-facet-list-item[data-term="Yes"]'
      );
      if (selectedItems.length > 0) {
        selectedItems.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.innerHTML = label.innerHTML
              .replace("No", "Non")
              .replace("Yes", "Oui");
          }
        });
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
